export interface allResponse<T> {
  data: T;
  result: ResultAPI;
}

interface ResultAPI {
  status: number;
  http_code: HttpCodes;
  info: string;
  errors: any;
}
type HttpCodes = 200 | 201 | 202 | 204 | 400 | 401 | 403 | 404 | 500 | 503;

export interface OrderDetailsResponseContent {
  order_id: string;
  transaction_id?: string;
  platform: string;
  order_date: string;
  term: number;
  total_products: number;
  total_price: number;
  url_callback: string;
  cart: Cart;
  applicant: Applicant;
  status: string;
  total_refunded: number;
  url_access: string;
  has_consent: boolean;
  process_type: string;
  view_mode: string;
  input_mode: string;
  invoice_id?: string;
  ocr_id?: string;
  is_preferred?: boolean;
  product_type?: string;
}

export interface Cart {
  id: string;
  cart_price?: number;
  shipping_price?: number;
  products: Product[];
}
export interface Product {
  id: string;
  reference: string;
  name: string;
  qty: number;
  price: number;
  attributes?: any;
  isChecked?: boolean;
  refundQty?: number;
}

export interface BillingAddress {
  country?: string;
  city: string;
  province?: string;
  postal_code: string;
  address: string;
  phone?: string;
}

export interface ShippingAddress {
  country?: string;
  city?: string;
  province?: string;
  postal_code?: string;
  address?: string;
  phone?: string;
}

export interface Applicant {
  id: string;
  name: string;
  last_name: string;
  email: string;
  document_id?: string;
  group?: string;
  gender?: string;
  nationality?: string;
  birth_date?: string;
  ip?: string;
  billing_address: BillingAddress;
  shipping_address?: ShippingAddress;
}

export enum NotificationType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WEB = 'WEB',
}

export interface PostOrder {
  process_type: string; // DEFAULT, MANAGED, SUGGESTED, DECISION
  order_date: string; // YYYY-MM-DD
  invoice_id?: string;
  ocr_id?: string;
  cart: Cart;
  term?: number;
  commercial_offer_id?: string;
  total_products: number;
  total_price: number;
  shipping?: Shipping;
  product_type?: string;
  input_mode?: string;
  platform?: string;
  url_callback?: string;
  transaction_id?: string;
  view_mode?: string;
  applicant: Applicant;
  is_preferred?: boolean;
}
export interface PostRetake {
  order_date: string; // YYYY-MM-DD
  term: number;
  total_products: number;
  total_price: number;
  product_type?: string;
  platform: string;
  applicant: Applicant;
  cart: Cart;
  url_callback?: string;
  transaction_id?: string;
  view_mode?: string;
  input_mode?: string;
}
export interface Shipping {
  name: string;
  method?: string;
}
export const MessageError = {
  ERROR_ORDER_ACCEPTED: '¡Vaya! No podemos recuperar pedidos con pago aceptado.',
  ERROR_ORDER_REFERENCE: '¡Vaya! No podemos recuperar pedidos con esa referencia.',
  ERROR_ORDER_RANGE: (totalPrice: number, minAvailability: number, maxAvailability: number) => `¡Vaya! El importe de esa referencia (${totalPrice}€) está fuera del rango de financiación. Recuerda que tiene que estar entre ${minAvailability} y ${maxAvailability}`,
  ERROR_ORDER_FILE: '¡Vaya! No podemos extraer la información de ese fichero. Por favor, prueba con otro.',
  ERROR_REFERENCE_NOT_FOUND: '¡Vaya! No podemos recuperar pedidos con esa referencia. Si decides continuar, recuerda que no podremos modificar tu stock',
};

export const DescriptionModalEntry = {
  ERROR_ORDER_DATA_FILE: 'No hemos podido leer los datos del fichero que has adjuntado. Por favor, asegurate de que el fichero sea legible y tenga los datos necesarios.',

};

export const DescriptionOrderLocalized = {
  DESCRIPTION_FILE: 'Estupendo, hemos podido leer el fichero que has subido. Estos son los datos principales:',
  DESCRIPTION_ORDER: 'Estupendo, hemos localizado la referencia indicada. Estos son los datos principales:',
};

export const TitleOrderLocalized = {
  INVOICE_LOCALIZED: '¡Presupuesto reconocido!',
  ORDER_LOCALIZED: '¡Pedido Localizado!',
};

export enum TermsType {
  ONLY_TERM = 'ONLY_TERM',
  FEW_TERMS = 'FEW_TERMS',
  MANY_TERMS = 'MANY_TERMS',
}
